// This enum is used when selecting a project.
// We want to only target translations, that have a language as key.
// Therefore, this enum is all the keys, that we are not interested in.
export enum KeysNotOfInterest {
  'image',
  'comment',
  'pluralcomment',
  'tag'
}